import React from 'react';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import {
  SupportContainer,
  SupportMain,
  HelpTitle,
  HelpContent,
  HelpLink
} from './css';

const Support = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    orderTracking: { helpTitleLabel, helpContent, linkLabel, supportLink }
  } = localizedStrings;

  return (
    <SupportContainer>
      <SupportMain>
        <HelpTitle>{helpTitleLabel}</HelpTitle>
        <HelpContent>
          {helpContent}{' '}
          <HelpLink href={supportLink} target="_blank">
            {linkLabel}
          </HelpLink>
        </HelpContent>
      </SupportMain>
    </SupportContainer>
  );
};

export default Support;
